export default {
  data(){
    return{
      vDateFR: Intl.DateTimeFormat('fr-CA', {day:'numeric', month:'long', year:'numeric'}),
      vDateEN: Intl.DateTimeFormat('en-CA', {day:'numeric', month:'long', year:'numeric'}),
      vDay: Intl.DateTimeFormat('fr-CA', {day:'2-digit'}),
      vMonthFR: Intl.DateTimeFormat('fr-CA', {month:'long'}),
      vMonthEN: Intl.DateTimeFormat('en-CA', {month:'long'}),
      vYear: Intl.DateTimeFormat('fr-CA', {year:'numeric'})
    }
  },
  methods: {
    getDateFR(date) {
      return this.vDateFR.format(new Date(`${date}T23:23:59Z`) || new Date());
    },
    getDateEN(date) {
      return this.vDateEN.format(new Date(`${date}T23:23:59Z`) || new Date());
    },
    getDay(date) {
      return this.vDay.format(new Date(`${date}T23:23:59Z`) || new Date());
    },
    getMonthFR(date) {
      return this.vMonthFR.format(new Date(`${date}T23:23:59Z`) || new Date());
    },
    getMonthEN(date) {
      return this.vMonthEN.format(new Date(`${date}T23:23:59Z`) || new Date());
    },
    getYear(date) {
      return this.vYear.format(new Date(`${date}T23:23:59Z`) || new Date());
    }
  }
}
